// extracted by mini-css-extract-plugin
export default {"root":"styles_root__8mOXW","imageContainer":"styles_imageContainer__GnFCS"};